module.exports = __webpack_public_path__ + "static/media/lid-open-pop.2afc8086.webm";